import { POST_HOW_TO_APPLY_START } from '../../types';

export const post_how_to_apply = (payload) => ({
  type: POST_HOW_TO_APPLY_START,
  payload,
});
